
















































































































































































































import { Component, Watch } from 'vue-property-decorator'
import Vue from 'vue'
import router from '../router'
import LessonProgress from './LessonProgress.vue'
import SelfCheckProgress from './SelfCheckProgress.vue'
import RewardCell from './RewardCell.vue'
import Snackbar from '@/components/Common/Snackbar.vue'
import Dialog from '@/components/Common/Dialog.vue'
import CrcMasterProvider, { CrcMasterModel } from '@/provider/crcMaster'
import {
  UserInfoProvider,
  ManagerUserInfoProvider,
  RewardStatusUserInfoProvider,
  UserInfoResult
} from '../provider/userInfo'
import { UserInfo } from '@/provider/interface'
import { AuthDynamoDB } from '../provider/dynamodb'
import AWSConfig from '@/assets/aws-exports'
import { Setting } from '@/setting'
import {
  CONSENT_WITHDRAWAL_STATUS_DECLINED,
  CONSENT_WITHDRAWAL_STATUS_RETRACTED,
  CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED
} from '@/constants'

const PAGING_LIST_NUMBER = 10
const ITEMS_PER_PAGE = 20

@Component({
  components: {
    LessonProgress,
    SelfCheckProgress,
    RewardCell,
    Snackbar,
    Dialog
  }
})
export default class UserList extends Vue {
  searchConditionUsername: string = ''
  searchConditionEmail: string = ''
  searchConditionCrcId: string = ''
  searchConditionAssignedAtStart: string = ''
  searchConditionAssignedAtEnd: string = ''
  searchConditionAssignedWeek: string = ''
  currentSearchCondition: {
    division: string;
    username?: string;
    email?:string;
    crcId?: string;
    startDate?: string;
    endDate?: string;
    rewardStatus?: string;
  } = {
    division: this.$store.getters.currentDivision.id
  }
  searchConditionRewardStatus: string = this.$store.getters.searchConditionRewardStatus

  menu1: boolean = false
  menu2: boolean = false

  provider: UserInfoProvider = new ManagerUserInfoProvider(
    new AuthDynamoDB(),
    AWSConfig.userInfoTable,
    this.$store.getters.currentDivision.id
  )
  rewardProvider: RewardStatusUserInfoProvider = new RewardStatusUserInfoProvider(
    new AuthDynamoDB(),
    AWSConfig.userInfoTable,
    this.$store.getters.currentDivision.id,
    this.$store.getters.searchConditionRewardStatus
  )

  cache: Array<UserInfo> = []
  lastEvaluatedKey: undefined | {division: string, sortDate: string} = undefined

  currentPage: number = 0
  listLoading: boolean = false

  crcItems: CrcMasterModel[] = []
  crcMasterProvider: CrcMasterProvider = new CrcMasterProvider()
  crcMasterTableCache: {[index:string]: CrcMasterModel} = {}

  loader: UserInfoLoader | undefined = undefined

  $refs!: {
    snackbar: Snackbar
    dialog: Dialog
  }

  get headers () {
    return [
      {
        text: 'username',
        value: 'username',
        sortable: false
      },
      {
        text: '割付日',
        value: 'assignDate',
        sortable: false
      },
      {
        text: '経過週',
        value: 'assignElapsedWeeks',
        sortable: false
      },
      {
        text: 'ニックネーム',
        value: 'nickname',
        sortable: false
      },
      {
        text: (Setting.ENABLE_PHONE_NUMBER ? 'email\n電話番号' : 'email'),
        value: 'email/phoneNumber',
        sortable: false
      },
      {
        text: '所属',
        value: 'crc',
        sortable: false
      },
      {
        text: 'レッスン進捗',
        value: 'lessonProgress',
        sortable: false
      },
      {
        text: 'セルフチェック',
        value: 'selfcheck',
        sortable: false
        // width: '30%'
      },
      {
        text: '謝礼',
        value: 'reward',
        sortable: false
      },
      {
        text: '最近1週間の\n起動時間（分）',
        value: 'activeTime',
        sortable: false
      },
      {
        text: 'コメント',
        value: 'comment',
        sortable: false
      }
    ]
  }

  get currentPageUserInfo () {
    console.log('currentPageUserInfo - currentPage: ', this.currentPage)
    console.log('currentPageUserInfo - cache: ', this.cache)
    const displayUserInfo = this.cache.slice(this.currentPage * ITEMS_PER_PAGE, (this.currentPage + 1) * ITEMS_PER_PAGE)
    return displayUserInfo
  }

  private userStatus (userInfo: UserInfo) {
    let status = userInfo.consentWithdrawalStatus
    if (status === CONSENT_WITHDRAWAL_STATUS_DECLINED) {
      return '参加拒否'
    } else if (status === CONSENT_WITHDRAWAL_STATUS_RETRACTED) {
      return '同意撤回'
    } else if (status === CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED) {
      return 'データ削除'
    }

    status = userInfo.status
    if (status === 'main') {
      return ''
    } else if (status === 'beforeAssignment') {
      return '割付前'
    } else if (status === 'beforeActivation') {
      return '有効化前'
    } else {
      console.log('Invalid status:', status)
      return ''
    }
  }

  get lastPageNumber () {
    console.log(this.displayPagingList[this.displayPagingList.length - 1])
    return this.displayPagingList[this.displayPagingList.length - 1]
  }

  /**
   * 現在選択しているページとキャッシュから表示すべきページングの配列を返します。
   *
   * @name displayPagingList
   * @function
   * @returns {undefined}
   */
  get displayPagingList () {
    const paging = this.pagingIndexList.filter((e) => {
      return e < Math.ceil(this.cache.length / ITEMS_PER_PAGE)
    }).map((e) => {
      return e + 1
    })
    console.log('displayPagingList - paging: ', paging)
    return paging
  }

  /**
   * 現在選択しているページから表示すべきページングの配列を返します。
   *
   * @name pagingIndexList
   * @function
   * @returns {undefined}
   */
  get pagingIndexList () {
    let startPage = this.currentPage - PAGING_LIST_NUMBER / 2
    if (startPage <= 0) {
      // startPageは1に丸める
      startPage = 0
    }
    return [...Array(PAGING_LIST_NUMBER).keys()].map((i) => {
      return startPage + i
    })
  }

  get isManager () {
    return this.$store.getters.adminType === 'manager'
  }

  toUserDetail (item: any) {
    return {
      name: 'UserDetail',
      params: {
        userId: item.userId,
        username: item.username
      }
    }
  }

  async clearSearch () {
    this.searchConditionUsername = ''
    this.searchConditionEmail = ''
    this.searchConditionCrcId = ''
    this.searchConditionAssignedAtStart = ''
    this.searchConditionAssignedAtEnd = ''
    this.searchConditionAssignedWeek = ''
  }

  async search () {
    console.log('search')
    if (this.searchConditionUsername !== '') {
      this.setupUsernameLoader()
    } else if (this.searchConditionEmail !== '') {
      this.setupEmailLoader()
    } else if (this.searchConditionCrcId && this.searchConditionCrcId !== '') {
      this.setupCrcIdLoader()
    } else if ((this.searchConditionAssignedAtStart !== undefined && this.searchConditionAssignedAtEnd !== undefined) && (this.searchConditionAssignedAtStart !== '' || this.searchConditionAssignedAtEnd !== '')) {
      if (!this.setupAssignedPeriodLoader()) {
        return
      }
    } else if (this.searchConditionAssignedWeek !== '' && this.searchConditionAssignedWeek !== undefined) {
      this.setupAssignedWeekLoader()
    } else {
      this.setupLoader()
    }
    this.loadPages(true)
  }

  setupUsernameLoader () {
    console.log('search - condition username: ', this.searchConditionUsername)
    const provider = this.getCurrentUserInfoProvider()
    this.loader = new UserInfoLoaderByUsername(provider, this.searchConditionUsername)
    this.currentSearchCondition.username = this.searchConditionUsername
  }

  setupEmailLoader () {
    console.log('search - condition email: ', this.searchConditionEmail)
    const provider = this.getCurrentUserInfoProvider()
    this.loader = new UserInfoLoaderByEmail(provider, this.searchConditionEmail)
    this.currentSearchCondition.email = this.searchConditionEmail
  }

  setupCrcIdLoader () {
    console.log('search - condition crc id: ', this.searchConditionCrcId)
    const provider = this.getCurrentUserInfoProvider()
    this.loader = new UserInfoLoaderByCrcId(provider, this.searchConditionCrcId)
    this.currentSearchCondition.crcId = this.searchConditionCrcId
  }

  setupAssignedWeekLoader () {
    console.log('search - condition assigned week: ', this.searchConditionAssignedWeek)

    const provider = this.getCurrentUserInfoProvider()
    const assignedWeek = Number(this.searchConditionAssignedWeek)
    this.loader = new UserInfoLoaderByAssignedWeek(provider, assignedWeek)

    const endDate = new Date(new Date().getTime() - 1000 * 3600 * 24 * 7 * assignedWeek)
    const startDate = new Date()
    startDate.setTime(startDate.getTime() - 1000 * 3600 * 24 * 7 * (assignedWeek + 1))
    this.currentSearchCondition.startDate = startDate.toISOString()
    this.currentSearchCondition.endDate = endDate.toISOString()
  }

  setupAssignedPeriodLoader () {
    if (this.searchConditionAssignedAtStart === '') {
      this.$emit('error', '割付日の開始日を指定してください')
      this.listLoading = false
      return false
    }
    const startDate = new Date(this.searchConditionAssignedAtStart)
    const endDate = this.searchConditionAssignedAtEnd !== '' ? new Date(this.searchConditionAssignedAtEnd) : new Date()
    if (startDate.getTime() > endDate.getTime()) {
      this.$emit('error', '割付日の範囲が正しくありません。開始日が終了日を上回っています')
      this.listLoading = false
      return false
    }
    console.log('search - assigned date : ', startDate, endDate)

    const provider = this.getCurrentUserInfoProvider()
    const assignedAtStart = this.searchConditionAssignedAtStart
    const assignedAtEnd = this.searchConditionAssignedAtEnd
    this.loader = new UserInfoLoaderByAssignedDateRange(provider, assignedAtStart, assignedAtEnd)

    this.currentSearchCondition.startDate = assignedAtStart
    this.currentSearchCondition.endDate = assignedAtEnd

    return true
  }

  setupLoader () {
    const provider = this.getCurrentUserInfoProvider()
    this.loader = new UserInfoLoader(provider)
  }

  getCurrentUserInfoProvider () {
    this.currentSearchCondition = {
      division: this.provider.getDivision()
    }

    if (this.searchConditionRewardStatus) {
      console.log('search - condition reward status: ', this.searchConditionRewardStatus)
      this.rewardProvider.setRewardStatus(this.searchConditionRewardStatus)
      this.currentSearchCondition.rewardStatus = this.searchConditionRewardStatus

      return this.rewardProvider
    } else {
      console.log('search - condition all')
      return this.provider
    }
  }

  get divisions () {
    console.log('divisions - divisionMaster: ', this.$store.getters.divisionMaster)
    return this.$store.getters.divisionMaster
  }

  mounted () {
    this.crcMasterProvider
      .load()
      .then((crcItems: CrcMasterModel[]) => {
        this.crcItems = crcItems // [new CrcMasterModel()].concat(crcItems)
        for (const item of crcItems) {
          this.crcMasterTableCache[item.id] = item
        }
      })
      .catch((error: any) => {
        throw new Error(error)
      })

    this.loader = new UserInfoLoader(this.provider)
    if (this.$store.getters.searchConditionRewardStatus) {
      this.searchConditionRewardStatus = this.$store.getters.searchConditionRewardStatus
      this.search()
    } else {
      this.loadPages(true)
    }
  }

  @Watch('currentPage')
  async onPageChanged () {
    this.loadPages(false)
  }

  getCrcName (crcId:string) {
    const item = this.crcMasterTableCache[crcId]
    if (item) {
      return item.displayName
    }
    return ''
  }

  async loadPages (clearCache: boolean = false) {
    console.log('loadPages - currentPage', this.currentPage)
    console.log('loadPages - cache.length', this.cache.length)
    console.log('loadPages - hasEnoughtCache', this.hasEnoughCache)
    console.log('loadPages - lastEvaluatedKey', this.lastEvaluatedKey)
    console.log('loadPages - endOfData', this.endOfData())
    if (this.loader === undefined) {
      console.log('loadPages - loader not found')
      return
    }
    this.listLoading = true
    if (clearCache) {
      console.log('loadPages - clearCache', clearCache)
      this.currentPage = 0
      this.cache = []
      this.lastEvaluatedKey = undefined
    }
    try {
      if (this.currentPage === 0 && this.cache.length === 0) {
        const { data, lastEvaluatedKey } = await this.loader.load(PAGING_LIST_NUMBER * ITEMS_PER_PAGE, undefined)
        this.cache = data
        this.updateLastEvaluatedKey(lastEvaluatedKey)
      } else if (this.hasEnoughCache) {
        console.log('loadPages - enough cache exists.')
        // キャッシュはあるが先のページ分のキャッシュはない
      } else if (this.endOfData()) {
        console.log('loadPages - end of data.')
      } else {
        const requireItems = (this.pagingIndexList[this.pagingIndexList.length - 1] + 1) * ITEMS_PER_PAGE - this.cache.length
        console.log('loadPages - require more items: ', requireItems, this.lastEvaluatedKey)
        const result = await this.loader.load(requireItems, this.lastEvaluatedKey)
        console.log('loadPages - result: ', result)
        this.cache = this.cache.concat(result.data)
        this.updateLastEvaluatedKey(result.lastEvaluatedKey)
      }
    } catch (e) {
      console.log(e)
      this.showSnackbar('更新に失敗しました。ネットワーク環境などを見直して再度実行して下さい。')
      this.listLoading = false
    }
    this.cache = this.cache.map((e) => {
      return {
        ...e,
        userStatus: this.userStatus(e),
        userStatusClass: { 'status-before-activation': e.status === 'beforeActivation', 'status-assignment': e.status === 'beforeAssignment' },
        lessonProgress: e.lesson ? e.lesson : [{ lessonId: 'pe', startedAt: null, locked: true, finishedAt: null }],
        selfcheckObj: e.selfcheck ? e.selfcheck : []
      }
    })
    this.listLoading = false
    console.log('loadPages - finished')
  }

  showSnackbar (message: string, second: number = 60) {
    this.$refs.snackbar.showSnackbar(message, second)
  }

  showDialog (title: string, message: string, callback:(value:boolean)=>void) {
    this.$refs.dialog.showDialog(title, message, callback)
  }

  // getでできるはずだがlastEvaluatedKeyの更新がリアクティブにならない・・・？
  // 呼び出し回数も多いわけでもなく、他の関数内でしか呼ばれないため一旦通常の関数で定義する
  // 試したもの: this.lastEvaluatedKey = Object.assign({}, this.lastEvaluatedKey, lastEvaluatedKey)
  //             this.$set(this, 'lastEvaluatedKey', lastEvaluatedKey)
  endOfData (): boolean {
    return this.lastEvaluatedKey === undefined
  }

  updateLastEvaluatedKey (lastEvaluatedKey: undefined | {division: string, sortDate: string}) {
    this.lastEvaluatedKey = lastEvaluatedKey
  }

  get hasEnoughCache (): boolean {
    const pages = this.pagingIndexList
    return this.cache.length >= (pages[pages.length - 1] + 1) * ITEMS_PER_PAGE
  }

  openUserPage (username: string) {
    router.push({ name: 'UserDetail', params: { username: username } })
  }

  async onAdminCommentBlur (adminComment: string, userInfo: any) {
    if (!userInfo) {
      return
    }
    if (adminComment === '') {
      return
    }
    this.$set(userInfo, 'adminComment', adminComment)
    const key = { division: userInfo.division, sortDate: userInfo.sortDate }
    await this.provider.updateValue(key, 'adminComment', userInfo.adminComment)
    console.log('onAdminCommentBlur - ', adminComment, userInfo)
  }

  async onRewardRecordStatusChange (event: any, userInfo: any) {
    console.log('onRewardRecordStatusChange - event:', event, 'userInfo:', userInfo)
    if (!event || !userInfo) {
      return
    }

    const checked = event.target.checked
    const rewardRecordStatusChange = async (yes: boolean) => {
      console.log('rewardRecordStatusChange - yes:', yes)
      if (yes) {
        try {
          const rewardStatus = checked ? 'processed' : 'unprocessed'
          const rewardRecord = checked ? new Date().toISOString() : null
          const key = { division: userInfo.division, sortDate: userInfo.sortDate }
          const attribute1 = { name: 'rewardStatus', value: rewardStatus }
          const attribute2 = { name: 'rewardRecord', value: rewardRecord }
          await this.provider.updateValues(key, attribute1, attribute2)
          userInfo.rewardStatus = rewardStatus
          userInfo.rewardRecord = rewardRecord
        } catch (e) {
          this.$emit('error', '謝礼記録の更新に失敗しました')
          event.target.checked = !checked
        }

        console.log('onRewardRecordStatusChange - userInfo:', userInfo)
        if (this.searchConditionRewardStatus) {
          this.search()
        }
      } else {
        event.target.checked = !checked
      }
    }

    this.showDialog(
      '謝礼記録',
      (checked ? '謝礼済' : '未謝礼') + 'に変更しますか？',
      rewardRecordStatusChange
    )
  }

  async onEncourageMailStatusChange (encourageMailStatus: any, userInfo: any) {
    if (!userInfo) {
      return
    }
    this.$set(userInfo, 'encourageMailStatus', encourageMailStatus)
    const key = { division: userInfo.division, sortDate: userInfo.sortDate }
    await this.provider.updateValue(key, 'encourageMailStatus', encourageMailStatus)
    console.log('onEncourageMailStatusChange - ', encourageMailStatus, userInfo)
  }

  onUpdateUserInfo () {
    this.loadPages(true)
  }

  onDivisionChange (v: string) {
    console.log('onDivisionChange - v', v)
    this.provider.setDivision(v)
    this.search()
  }

  onRewardStatusChange (v: string) {
    console.log('onRewardStatusChange - v', v)
    this.searchConditionRewardStatus = v
    this.search()
  }

  async getUserInfoUpdatedAt (): Promise<Array<any>> {
    return this.provider.loadUpdatedAt()
  }

  onClickEMailAddress (mail: string) {
    console.log(mail)
    this.$copyText(mail).then(() => {
      this.showSnackbar(`クリップボードにコピーしました. ${mail}`, 7)
    })
  }
}

class UserInfoLoader {
  constructor (protected provider: UserInfoProvider) {
  }
  async load (count: number, lastEvaluatedKey?: {division: string, sortDate: string}): Promise<UserInfoResult> {
    console.log('loadItems - count: ', count)
    console.log('loadItems - lastEvaluatedKey: ', lastEvaluatedKey)
    let result = await this.provider.load(count, lastEvaluatedKey)
    // console.log(result)
    return result
  }
}

class UserInfoLoaderByUsername extends UserInfoLoader {
  constructor (provider: UserInfoProvider, private username: string) {
    super(provider)
  }
  async load (count: number, lastEvaluatedKey?: {division: string, sortDate: string}): Promise<UserInfoResult> {
    console.log('UserInfoLoaderByUsername - load count: ', count)
    console.log('UserInfoLoaderByUsername - load lastEvaluatedKey: ', lastEvaluatedKey)
    console.log('UserInfoLoaderByUsername - load username: ', this.username)
    let result = await this.provider.loadByUsername(this.username)
    return result
  }
}

class UserInfoLoaderByEmail extends UserInfoLoader {
  constructor (provider: UserInfoProvider, private email: string) {
    super(provider)
  }
  async load (count: number, lastEvaluatedKey?: {division: string, sortDate: string}): Promise<UserInfoResult> {
    console.log('UserInfoLoaderByEmail - load count: ', count)
    console.log('UserInfoLoaderByEmail - load lastEvaluatedKey: ', lastEvaluatedKey)
    console.log('UserInfoLoaderByEmail - load username: ', this.email)
    let result = await this.provider.loadByEmail(this.email)
    return result
  }
}

class UserInfoLoaderByCrcId extends UserInfoLoader {
  constructor (provider: UserInfoProvider, private crcId: string) {
    super(provider)
  }
  async load (count: number, lastEvaluatedKey?: {division: string, sortDate: string}): Promise<UserInfoResult> {
    console.log('UserInfoLoaderByCrcId - load count: ', count)
    console.log('UserInfoLoaderByCrcId - load lastEvaluatedKey: ', lastEvaluatedKey)
    console.log('UserInfoLoaderByCrcId - load crcId: ', this.crcId)
    let result = await this.provider.loadByCrcId(count, this.crcId, lastEvaluatedKey)
    return result
  }
}

class UserInfoLoaderByAssignedDateRange extends UserInfoLoader {
  constructor (provider: UserInfoProvider, private startDate: string, private endDate: string) {
    super(provider)
  }
  async load (count: number, lastEvaluatedKey?: {division: string, sortDate: string}): Promise<UserInfoResult> {
    const assignedAtStartDate = new Date(this.startDate)
    const assignedAtEndDate = this.endDate !== ''
      ? new Date(this.endDate)
      : new Date()
    assignedAtStartDate.setTime(assignedAtStartDate.getTime() - 1000 * 3600 * 9)
    assignedAtEndDate.setTime(assignedAtEndDate.getTime() - 1000 * 3600 * 9)
    assignedAtEndDate.setTime(assignedAtEndDate.getTime() + 1000 * 3600 * 24 - 1)
    console.log('UserInfoLoaderByAssignedDateRange - load count: ', count)
    console.log('UserInfoLoaderByAssignedDateRange - load lastEvaluatedKey: ', lastEvaluatedKey)
    console.log('UserInfoLoaderByAssignedDateRange - load start: ', assignedAtStartDate)
    console.log('UserInfoLoaderByAssignedDateRange - load end: ', assignedAtEndDate)
    const result = await this.provider.loadBySortDateRange(count, assignedAtStartDate, assignedAtEndDate, lastEvaluatedKey)
    return result
  }
}

class UserInfoLoaderByAssignedWeek extends UserInfoLoader {
  constructor (provider: UserInfoProvider, private assignedWeek: number) {
    super(provider)
  }
  async load (count: number, lastEvaluatedKey?: {division: string, sortDate: string}): Promise<UserInfoResult> {
    const endDate = new Date(new Date().getTime() - 1000 * 3600 * 24 * 7 * this.assignedWeek)
    const startDate = new Date()
    startDate.setTime(startDate.getTime() - 1000 * 3600 * 24 * 7 * (this.assignedWeek + 1))
    console.log('UserInfoLoaderByAssignedWeek - load count: ', count)
    console.log('UserInfoLoaderByAssignedWeek - load lastEvaluatedKey: ', lastEvaluatedKey)
    console.log('UserInfoLoaderByAssignedWeek - load start: ', startDate)
    console.log('UserInfoLoaderByAssignedWeek - load end: ', endDate)
    const result = await this.provider.loadBySortDateRange(count, startDate, endDate, lastEvaluatedKey)
    return result
  }
}
